// test will pour vercel deploiement sur dev environnement
import React from "react";
import ReactDOM from "react-dom/client";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import App from "./components/App";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
//import LienAdim from './components/Redirection/LienAdim';
//import LienDisconnect from './components/Redirection/LienDisconnect';
//import LienDocumentation from './components/Redirection/LienDocumentation';
//import idCopieurReleve from './reducers/idCopieurReleve'
//import showReleve1 from './reducers/showReleve1'
//import stateAllButtons from './reducers/stateAllButtons'
import i18n from "./util/i18n"; // For changing the language
import { Suspense } from "react"; // Ajouté pour éviter le crash de l'app quand : user not connecter & try to access /home
// comment will pour push modif de AA du 21/02/25

let firebaseConfig = {};

// Check if environment variables are available (from .env file or Vercel)
const environment = process.env.REACT_APP_ENVIRONMENT;

if (!environment) {
  // TODO: handle error
}

firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

// Initialize Firebase

firebase.initializeApp(firebaseConfig);
firebase
  .firestore()
  .settings({ experimentalAutoDetectLongPolling: true, merge: true }); //listening

const auth = firebase.auth();

// Si l'utilisateur n'est pas encore connecté, on récupère la langue de son navigateur et on la passe à i18n
if (!auth.currentUser) {
  const lang = navigator.language.split("-")[0];
  // console.log("langue de l'utilisateur (Navigateur)", lang);
  i18n.changeLanguage(lang);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // {<React.StrictMode>}
  <React.StrictMode>
    <>
      <Header />
      <Suspense fallback={<div>Loading...</div>}>
        <App />
      </Suspense>

      <Footer />
    </>
  </React.StrictMode>
  // {</React.StrictMode>}
);
